import './App.css';
import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';

import Login from './pages/login/Login';
import StudentHomepage from './pages/studentHomepage/StudentHomepage';
import ViewProjects from './pages/viewProjects/ViewProjects';
import CreateEditProject from './pages/createEditProject/CreateEditProject';
import ViewShortlist from './pages/viewShortlist/ViewShortlist';
import MakeChoices from './pages/makeChoices/MakeChoices';
import ViewFinalAllocation from './pages/viewFinalAllocation/ViewFinalAllocation';

import LecturerHomepage from './lecturerPages/lecturerHomepage/LecturerHomepage';
import LecturerViewProjects from './lecturerPages/lecturerViewProjects/LecturerViewProjects';
import LecturerCreateEditProject from './lecturerPages/lecturerCreateEditProject/LecturerCreateEditProject';
import LecturerEditInfo from './lecturerPages/lecturerEditInfo/LecturerEditInfo';
import LecturerViewFinalAllocation from './lecturerPages/lecturerViewFinalAllocation/LecturerViewFinalAllocation';

import AdminHomepage from './adminPages/adminHomepage/AdminHomepage';
import AdminDates from './adminPages/adminDates/AdminDates';
import AdminManageStudents from './adminPages/adminManageStudents/AdminManageStudents';
import AdminManageLecturers from './adminPages/adminManageLecturers/AdminManageLecturers';
import AdminManageUsers from './adminPages/adminManageUsers/AdminManageUsers';

function App() {
  const LoggingIn = () => (
    <div>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </div>
  )

  return (
    
    <Router>
      <div className="app">
        <div className='appContainer'>
          <Routes>
            <Route path='/' exact element={<LoggingIn/>} />
            <Route path='/login' exact element={<LoggingIn/>} />
            <Route path='/studentHomepage' element={<StudentHomepage/>} />
            <Route path='/viewProjects' element={<ViewProjects/>} />
            <Route path='/createEditProject' element={<CreateEditProject/>} />
            <Route path='/viewShortlist' element={<ViewShortlist/>} />
            <Route path='/makeChoices' element={<MakeChoices/>} />
            <Route path='/viewFinalAllocation' element={<ViewFinalAllocation/>} />

            <Route path='/lecturerHomepage' element={<LecturerHomepage/>} />
            <Route path='/lecturerViewProjects' element={<LecturerViewProjects/>} />
            <Route path='/lecturerCreateEditProject' element={<LecturerCreateEditProject/>} />
            <Route path='/lecturerViewFinalAllocation' element={<LecturerViewFinalAllocation/>} />
            <Route path='/lecturerEditInfo' element={<LecturerEditInfo/>} />

            <Route path="/adminHomepage" element={<AdminHomepage/>} />
            <Route path="/adminDates" element={<AdminDates/>} />
            <Route path="/adminManageStudents" element={<AdminManageStudents/>} />
            <Route path="/adminManageLecturers" element={<AdminManageLecturers/>} />
            <Route path="/adminManageUsers" element={<AdminManageUsers/>} />
          </Routes>
        </div>
      </div>
    </Router>
  );

}

export default App;
